import * as dc from "@/components/layout/list/defaultType";
import { ClipboardProp, DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import {
  convertFormValues,
  getDateDiff,
  getFormDateDiff,
  getInputValueCheck,
  runFormFunction,
  setFormClass,
} from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { getTranslate } from "@/util/arrayutil";
import { checkEmpty } from "@/util/stringutil";
import { qcCommonCols } from "../../inputCols/qcCols";
import { beaninfoSelectList } from "../../inputCols/beaninfoCols";
import { enLocale } from "@/i18n/routing";
import { brewingClipboard } from "../../inputCols/clipboard";
import { brewingChangeCalc, brewingCommon, brewingDefault, brewingInit, brewingType } from "../../inputCols/brewingCols";
import { qcNamesCols, qcResultClipboard } from "./UserQC";
export const BrewingInfo = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;

  const utcOffset = dayjs().utcOffset() * 60000;
  const brewingTypeMap: Record<string, string> = {
    UserBrewing: "user",
    CafeBrewing: "cafe",
    RoasterBrewing: "roaster",
    UserNote: "usernote",
  };

  switch (params?.page.page ?? "") {
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"roaster_user","system_table_pk":["roaster_seq","roaster_user_seq"],"system_table_page":"RoasterUser","system_table_path":"roaster/user/list","system_table_page_name":"RoasterUser","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"SMNG","system_table_mapper":"roasteruser","system_table_detail_result":"detail_result","system_table_search_column":["roaster_user_auth","roaster_user_use"],"system_table_search_select":["roaster_user_name","roaster_user_nick"],"system_table_order_column":["roaster_user_auth","roaster_user_nick","roaster_user_name","rgst_at"],"system_table_default_name_column":"roaster_user_name","system_table_use_column":"roaster_user_use"}
    //--info--}
    case "UserBrewing":
    case "CafeBrewing":
    case "RoasterBrewing":
      const brewing_type = brewingTypeMap[params?.page.page ?? ""] ?? "user";
      return {
        ...result,
        dataFetch: { fetchUrl: `/api/info/${brewing_type}/brewing/default/` },
        dataResultName: "detail_result",
        dataName: "BrewingInfo",
        useDefaultId: false,
        editCheck: true,
        useList: false,
        clipboard: brewingClipboard,
        timer: dc.brewingTimer,
        dataInit: (data: any) => brewingInit(form?.current, formFunction?.current, dataFunction?.current, data, params?.setTimer),
        dataCols: {
          brewing_name_locale: {
            ...dc.inputFull,
            minLength: params?.locale !== enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: dc.strongLabelClassName,
            required: params?.locale !== enLocale ? true : undefined,
            read: { display: params?.locale !== enLocale ? true : false, variant: "borderless" },
          },
          brewing_name: {
            ...dc.inputFull,
            minLength: params?.locale === enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: dc.strongLabelClassName,
            required: params?.locale === enLocale ? true : undefined,
            read: { display: params?.locale !== enLocale ? false : true, variant: "borderless" },
          },
          ...brewingDefault(
            t,
            form,
            formMemo?.current,
            formFunction?.current,
            dataFunction?.current,
            params?.setTimer,
            params?.locale,
            "info",
            "default",
            true,
          ),
        },
        listColLinkField: ["public_uuid"],
        base64Field: ["public_uuid"],
        undoButton: false,
        cancelButton: false,
        removeButton: false,
      };
    case "UserNote":
      return {
        ...result,
        dataFetch: { fetchUrl: `/api/info/user/note/default/` },
        // dataFetch: { fetchUrl: "/api/user/qc/coffeebean/detail/" },
        dataResultName: "detail_result",
        dataMerge: "detail_result_step",
        dataName: "UserNote",
        // dataFormClassName: "hidden_blending_info",
        dataFormClassDefault: ["hidden_blending_info", "hidden_step_detail", "hidden_brewing_result", "hidden_cupnote_flavor_wheel"],
        useDefaultId: false,
        editCheck: true,
        useList: false,
        clipboard: qcResultClipboard(formFunction?.current),
        timer: dc.brewingTimer,
        dataInit: (data: any, params: any, mode?: string) => {
          const checkData = data ?? {};
          if (params?.setTimer) {
            params.setTimer({ timer: dc.brewingTimer, start: undefined });
          }
          const setValues: Record<string, any> = {
            brewing_date_term: getDateDiff(checkData.blending_result_date, checkData.cupnote_date),
          };
          setFormClass(dataFunction?.current, {
            hidden_blending_info: !((checkData["blending_info_detail_use"] ?? 0) === 1),
            brewing_detail_use: checkData["brewing_detail_use"] ?? false,
            brewing_espresso_use: checkData["brewing_type"] === "ESP",
            brewing_drip_use: checkData["brewing_type"] === "DRP",
            hidden_step_detail: !((checkData["brewing_step_use"] ?? 0) === 1),
            hidden_brewing_result: !((checkData["brewing_result_use"] ?? 0) === 1),
            satis_detail_use: checkData["cupnote_satis_detail"],
            hidden_cupnote_flavor_wheel: !((checkData["cupnote_flavor_wheel_use"] ?? 0) === 1),
          });

          if (form?.current) {
            const coffeebean_uuid = data.coffeebean_uuid;
            if (checkEmpty(form.current.getFieldValue("coffeebean_uuid_dummy")) && !checkEmpty(coffeebean_uuid)) {
              setValues.coffeebean_uuid_dummy = coffeebean_uuid;
            }
            if (checkData.blending_country_list) {
              if (typeof checkData.blending_country_list === "string") {
                setValues.blending_country_code = checkData.blending_country_list;
              } else if (checkData.blending_country_list instanceof Array && checkData.blending_country_list.lenght === 1) {
                setValues.blending_country_code = checkData.blending_country_list[0];
              }
            }
            Debug("UserQCCoffebean Data", mode, data, setValues);
            form.current.setFieldsValue(setValues);
          }
          setTimeout(() => {
            if (setValues.blending_country_code) {
              runFormFunction(formFunction?.current, "blending_country_map", "setSelectCountry", [setValues.blending_country_code]);
              setTimeout(() => {
                runFormFunction(formFunction?.current, "blending_country_map", "setSelectCountry", [setValues.blending_country_code]);
              }, dc.setTimeoutDelay * 4);
              runFormFunction(formFunction?.current, ["blending_region_seq", "blending_farm_seq"], "changeLoad");
            }
            brewingChangeCalc(form?.current, dataFunction?.current);
          }, dc.setTimeoutShort);

          if ((checkData["cupnote_flavor_wheel_use"] ?? 0) === 1) {
            const check_wheel = { cnt: 0, find: false };
            const timer = setInterval(() => {
              const objs = document.querySelectorAll("form.ant-form .rt-Flex.data-chart.FlavorWheel svg > g > g");
              check_wheel.cnt++;
              if (objs && objs.length > 0) {
                check_wheel.find = true;
                runFormFunction(formFunction?.current, "cupnote_flavor_wheel", "changeData");
                const rotate =
                  getInputValueCheck(form?.current, formMemo?.current, dataFunction?.current, data, "cupnote_flavor_wheel_rotate") ?? 0;
                Debug("qcCommonInit", rotate);
                const objs = document.querySelectorAll("form.ant-form .rt-Flex.data-chart.FlavorWheel svg > g > g");
                objs.forEach((g) => {
                  const obj = g as SVGGElement;
                  const ctm = getTranslate(obj);
                  if (ctm) {
                    obj.setAttribute("transform", `translate(${ctm.x}, ${ctm.y}) rotate(${rotate})`);
                  }
                });
              }
              Debug(check_wheel);
              if (check_wheel.find || check_wheel.cnt > 4) {
                clearInterval(timer);
              }
            }, dc.setTimeoutDelay);
          }
        },
        dataCols: {
          ...qcNamesCols(params?.locale),
          coffeebean_serail: {
            label: "product_serial",
            // labelClassName: dc.mobileHidden,
            read: { display: "notNull", displayCheckIds: ["coffeebean_uuid"] },
            valueClassName: "flex-col md:flex-row mobile_multi",
            fieldId: {
              coffeebean_serail_uuid: {
                fieldId: {
                  coffeebean_uuid_dummy: {
                    ...dc.input,
                    fieldId: "coffeebean_uuid",
                    inputClassName: dc.inputCountryClassName,
                    widthFull: false,
                    saveData: false,
                  },
                },
              },
              coffeebean_serail_type: {
                flexClassName: "ml-0 mt-2 md:ml-2 md:mt-0",
                fieldId: {
                  coffeebean_uuid_type: {
                    ...dc.select,
                    codeGroup: "BNDV",
                    inputClassName: dc.inputSelectWidth,
                    changePass: true,
                    selectPropOption: { reloadButton: false },
                  },
                },
              },
              coffeebean_info_link: {
                ...dc.link,
                fieldId: "coffeebean_uuid",
                linkOption: {
                  pathname: {
                    field: "coffeebean_uuid_type",
                    path: { CAFEDF: "/info/bean/cd/", CAFEDT: "/info/bean/ct/", RSTRDF: "/info/bean/rd/", RSTRDT: "/info/bean/rt/" },
                  },
                },
                linkPropOption: {
                  title: " ",
                  linkButtonName: "CoffeeBean",
                  linkButtonFront: "just",
                  linkButtonTitle: "coffeebeaninfo_label",
                  // linkButtonTitleTooltip: false,
                  linkButtonNewTab: false,
                },
                edit: { display: false },
                read: { display: "notNull", displayCheckIds: ["coffeebean_uuid"] },
                checkUserType: ["SADMIN", "ADMIN", "TESTER", "PAID", "USER"],
              },
            },
          },
          coffeebean_uuid: {
            ...dc.input,
            itemClassName: "hidden",

            inputClassName: dc.inputCountryClassName,
            widthFull: false,
            disabled: true,
            changePass: true,
            read: { display: "notNull" },
          },
          blending_result_date_dummy: {
            label: "blending_result_date",
            // itemClassName: "hidden",
            read: { display: "notNull", displayCheckIds: ["blending_result_date"] },
            fieldId: {
              blending_result_date: {
                ...dc.date,
                noItem: false,
                onChange: () => {
                  form?.current?.setFieldValue("brewing_date_term", getFormDateDiff(form?.current, "blending_result_date", "cupnote_date"));
                },
              },
              brewing_date_term: {
                ...dc.dayNumber,

                noItem: false,
                readOnly: true,
                tooltip: "brewing_date_term",
              },
            },
          },
          cupnote_date: {
            ...dc.date,
            noItem: false,
            placeholder: "cupnote_date",
            create: { defaultValue: dayjs().format("YYYY-MM-DD") },
            update: { disabled: true },
            onChange: (e) => {
              form?.current?.setFieldValue("brewing_date_term", getFormDateDiff(form?.current, "blending_result_date", "cupnote_date"));
            },
          },
          // blending_result_select: {
          //       label: "blending_result_select_label",
          //       labelClassName: dc.strongLabelClassName,
          //       fieldId: {
          //       },
          //     },
          blending_info_detail_div: {
            label: "blending_info_detail_use",
            read: { display: false },
            fieldId: {
              blending_info_detail_use: {
                ...dc.use,
                inputClassName: "my-auto",
                read: { display: false },
                create: { defaultValue: false },
                onChange: (e) => {
                  setFormClass(dataFunction?.current, { hidden_blending_info: !e.value });
                },
                changePass: true,
              },
              blending_info_detail_button: {
                ...dc.textButton("ArrowsOut", "brewing_expand_all", () => {
                  const expand_all_value = {
                    blending_info_detail_use: 1,
                    brewing_result_use: 1,
                    brewing_detail_use: 1,
                    brewing_step_use: 1,
                    cupnote_satis_detail: 1,
                    cupnote_flavor_wheel_use: 1,
                  };
                  form?.current?.setFieldsValue(expand_all_value);
                  setFormClass(dataFunction?.current, {
                    hidden_blending_info: false,
                    hidden_brewing_result: false,
                    hidden_step_detail: false,
                    brewing_detail_use: true,
                    satis_detail_use: true,
                    hidden_cupnote_flavor_wheel: false,
                  });
                }),
                read: { display: false },
              },
            },
          },
          blending_info_detail_guide: { ...dc.guideDefault, fixedValue: "blending_info_detail_guide", read: { display: false } },
          ...beaninfoSelectList(form, formFunction?.current, params?.locale, true),
          div_0: { ...dc.itemDiv, itemClassName: dc.itemDiv.itemClassName + " brewing_result" },
          brewing_result_use: {
            ...dc.use,
            itemClassName: "blending_info",
            inputClassName: "my-auto",
            read: { display: false },
            create: { defaultValue: false },
            onChange: (e) => {
              setFormClass(dataFunction?.current, { hidden_brewing_result: !e.value });
            },
            changePass: true,
          },
          brewing_seq: {
            ...dc.brewingSelect(params?.locale, false),
            itemClassName: "brewing_result",
            label: "brewing_select_label",
            dataUrl: "/api/user/brewing/default/code",
            onChange: (data) => {
              const temp_result = runFormFunction(formFunction?.current, "brewing_seq", "selectData");
              Debug(temp_result);
              const select_data = temp_result.result;
              if (select_data) {
                const convert_values = convertFormValues(formMemo?.current, select_data, undefined, []);
                if (convert_values) {
                  convert_values["brewing_result_use"] = 1;
                  if (checkEmpty(form?.current?.getFieldValue("cupnote_date"))) convert_values["cupnote_date"] = dayjs();
                  form?.current?.setFieldsValue(convert_values);
                  setTimeout(() => {
                    runFormFunction(formFunction?.current, ["blending_seq", "blending_result_seq"], "changeLoad");
                  }, dc.setTimeoutShort);
                }
                setFormClass(dataFunction?.current, {
                  hidden_brewing_result: !true,
                });
                brewingInit(form?.current, formFunction?.current, dataFunction?.current, select_data, params?.setTimer);
              }
            },
            read: { display: "notNull" },
            update: { disabled: true, selectPropOption: { reloadButton: false } },
          },

          ...brewingDefault(
            t,
            form,
            formMemo?.current,
            formFunction?.current,
            dataFunction?.current,
            params?.setTimer,
            params?.locale,
            "info",
            "result",
            false,
          ),
          condition: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            itemClassName: "brewing_result",
            read: { display: "notNull", displayCheckIds: ["outside_air", "inside_air", "outside_hum", "inside_hum"] },
            fieldId: {
              condition_air: {
                ...dc.airTemp,
                readOnly: true,
                disabled: true,
                variant: "borderless",
                unit: "",
              },
              condition_hum: {
                ...dc.hum,
                readOnly: true,
                disabled: true,
                variant: "borderless",
                unit: "",
                read: { display: "notNull", displayCheckIds: ["outside_hum", "inside_hum"] },
              },
            },
          },
          outside: {
            itemClassName: "brewing_result",
            read: { display: "notNull", displayCheckIds: ["outside_air", "outside_hum"] },
            edit: { label: dc.weatherButton(form) },
            fieldId: {
              outside_air: dc.airTemp,
              outside_hum: { ...dc.hum, read: { display: "notNull", displayCheckIds: undefined } },
            },
          },
          inside: {
            itemClassName: "brewing_result",
            read: { display: "notNull", displayCheckIds: ["inside_air", "inside_hum"] },
            fieldId: {
              inside_air: dc.airTemp,
              inside_hum: { ...dc.hum, read: { display: "notNull", displayCheckIds: undefined } },
            },
          },

          brewing_split: {
            label: "blank",
            itemClassName: "!hidden",
          },
          ...qcCommonCols(form, formFunction?.current, dataFunction?.current, params?.locale, ["cupnote_name"], alertContext, ta, "Coffee"),
        },
        listColLinkField: ["public_uuid"],
        base64Field: ["public_uuid"],
        undoButton: false,
        cancelButton: false,
        removeButton: false,
      };

    default:
      return undefined;
  }
};
